import ModuleBootstrapper from '../common/ModuleBootstrapper/ModuleBootstrapper';

const config = {
    name: 'shipment-manifests',
    actions: [
        { type: 'request', name: 'getAll' },
        { type: 'request', name: 'getOne' }
    ],
    endpoints: {
        shipmentManifests: '/v2/shipment-manifests',
        shipmentManifest: '/v2/shipment-manifests/[id]',
        shipmentManifestPdf: '/v2/shipment-manifests/[id]/pdf',
        registerShipment: '/v2/shipment-manifests/register-shipment',
        closeManifest: '/v2/shipment-manifests/[id]/close',
        deleteItem: '/v2/shipment-manifests/[manifestId]/items/[itemId]'
    },
    defaults: {},
    validations: {}
}

const Config = {
    Actions: ModuleBootstrapper.getActions(config.name, config.actions),
    Endpoints: config.endpoints,
    Defaults: config.defaults,
    Validations: config.validations,
    ...ModuleBootstrapper.getUtils(),
}

export default Config;
